import React from 'react';
import {Route, Switch} from 'react-router-dom';
import CGU from './cgu/CGU';
import NotFoundPage from './common/NotFoundPage';
import ScrollToTop from './common/ScrollToTop';
import Home from './home/HomepageView';
import LegalNotice from './legalnotice/LegalNotice';
import PartnerForm from './partner/PartnerForm';
import Privacy from './privacy/Privacy';
import './Public.scss';

function Public() {
  return (
    <div className="public-layout">
      <ScrollToTop/>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/become_partner" component={PartnerForm} />
        <Route exact path="/cgu" component={CGU} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/legal-notice" component={LegalNotice} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </div>
  );
}

export default Public;
